import InfoIcon from "assets/icons/InfoIcon";
import { useTranslation } from "react-i18next";
import { Icon } from "ui";

import styles from "./IndelibleCategoryMessage.module.scss";

const IndelibleCategoryMessage = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.message}>
      <Icon as={InfoIcon} boxSize={24} color="#ff0033" />
      <p>
        {t("The category cannot be deleted while there are products in it.")}
      </p>
    </div>
  );
};

export default IndelibleCategoryMessage;
